import { useCallback, useEffect, useRef } from 'react';

export default function useDebouncedCallback(fn, delay) {
  const ref = useRef({ fn, t: null });
  useEffect(() => { ref.current.fn = fn; }, [fn]);

  return useCallback((...args) => {
    if (ref.current.t) clearTimeout(ref.current.t);
    ref.current.t = setTimeout(() => ref.current.fn(...args), delay);
  }, [delay]);
}